import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 20000,
});

export const submitLead = async (payload) => {
  const { data } = await api.post("/leads", payload);
  return data;
};

export const verifyAdmin = async (token) => {
  const { data } = await api.post("/admin/verify", null, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const fetchLeads = async (token) => {
  const { data } = await api.get("/admin/leads", {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const fetchStats = async (token) => {
  const { data } = await api.get("/admin/stats", {
    headers: { "X-Admin-Token": token },
  });
  return data;
};

export const updateLeadStatus = async (token, id, status) => {
  const { data } = await api.patch(`/admin/leads/${id}`, { status }, {
    headers: { "X-Admin-Token": token },
  });
  return data;
};
